import { type ReactNode } from "react";

import Loader from "../Loader/Loader";
import styles from "./TileGrid.module.scss";

interface TileGridProps {
  children?: ReactNode;
  className?: string;
  loading?: boolean;
  variant?: "default" | "compact";
}

export const GridLoader = ({ className }: { className?: string }) => (
  <div className={`${styles.gridLoader} ${className ?? ""}`}>
    <Loader />
  </div>
);

const TileGrid = ({
  children,
  className,
  loading,
  variant = "default",
}: TileGridProps) => {
  const gridClass =
    variant === "compact" ? `${styles.grid} ${styles.gridCompact}` : styles.grid;

  if (loading) {
    return <GridLoader className={className} />;
  }

  return (
    <div className={`${gridClass} ${className ?? ""}`}>{children}</div>
  );
};

export default TileGrid;
